export default () => ({
  categories: {
    marginBottom: '0.4rem',
    height: '38px',
  },
});
